export enum IntegrationType {
  C3 = 'C3',
  Middleware = 'MIDDLEWARE',
  Standalone = 'STANDALONE',
}
